import React from "react";
import { Anchor, Button, UserMenu } from "@ebscois/react-component-library";
import { Link } from "react-router-dom";

const Personalized = ({
  messaging,
  userDetails,
  linkURLs,
  customLinks,
  onMenuItemClick,
}) => {
  const handleMenuItemClick = (e, linkData) => {
    onMenuItemClick(linkData);
  };

  const additionalProps = linkURLs.signOutURL
    ? { signOutProps: { href: linkURLs.signOutURL } }
    : {};

  const getMenuItems = (customLinks) => {
    const links = [];
    customLinks.forEach((link) => {
      if (link.path) {
        links.push(
          <Anchor
            href={link.path}
            linkComponent={link.isExternal ? "a" : Link}
            target={link.isExternal ? "_blank" : undefined}
            onClick={(e) => handleMenuItemClick(e, link)}
            rel={link.isExternal ? "noopener noreferrer" : undefined}
          >
            {link.text}
          </Anchor>
        );
      } else {
        links.push(
          <Button kind="anchor" onClick={(e) => handleMenuItemClick(e, link)}>
            {link.text}
          </Button>
        );
      }
    });
    return links;
  };

  return (
    <UserMenu
      data-testid="menu-personalized"
      fontSize="sm"
      width="22rem"
      username={userDetails.displayName}
      title={userDetails.affiliationName || "Individual Subscriber"}
      initials={userDetails.initials}
      alert={messaging.alert}
      menuItems={getMenuItems(customLinks)}
      {...additionalProps}
    >
      {messaging.subscribe && (
        <Anchor fontSize="sm" fontWeight="bold" href={linkURLs.subscribeURL}>
          {messaging.subscribe}
        </Anchor>
      )}
    </UserMenu>
  );
};

export default Personalized;
